/**
 *  Module for the nav flyout menu
 */

const NavigationArrows = function(app) {
  /**
   *  Private Properties/Methods
   */
  const configure = app.configure,
    _ = require('lodash'),
    $container = app.$container;

  /* =========================================
  =            Navigation Arrows             =
  ========================================= */
  const PREV_ARROW_CLASS = '.fc-navigation-arrow-prev';
  const NEXT_ARROW_CLASS = '.fc-navigation-arrow-next';
  const DISABLED_ARROW_CLASS = 'fc-navigation-arrow-disabled';
  const setPrevArrowStatus = () => {
    if (!app.menu.currentIndex || app.menu.currentIndex < 1) {
      $container.find(PREV_ARROW_CLASS).addClass(DISABLED_ARROW_CLASS);
    } else {
      $container.find(PREV_ARROW_CLASS).removeClass(DISABLED_ARROW_CLASS);
    }
  };
  const setNextArrowStatus = (maxItems = 1) => {
    const index = app.menu.currentIndex || 0;
    if (index >= maxItems - 1) {
      $container.find(NEXT_ARROW_CLASS).addClass(DISABLED_ARROW_CLASS);
    } else {
      $container.find(NEXT_ARROW_CLASS).removeClass(DISABLED_ARROW_CLASS);
    }
  };
  const setNavigationArrowsStatus = (maxItems) => {
    setPrevArrowStatus();
    setNextArrowStatus(maxItems);
  };
  const addBottomNavigationArrows = (menu) => {
    const prevOptions = {
      type: 'button',
      container: PREV_ARROW_CLASS,
      title: app.l10n.getLang('arrowsControl_prev', 'Previous'),
      onClick() {
        if (app.menu.currentIndex > 0) {
          menu.trigger('attributeList:setIndex', 'prev');
        }
      }
    };
    const nextOptions = {
      type: 'button',
      title: app.l10n.getLang('arrowsControl_next', 'next'),
      container: NEXT_ARROW_CLASS,
      onClick() {
        const index = app.menu.currentIndex || 0;
        if (index < app.getRenderableAttributes().length - 1) {
          menu.trigger('attributeList:setIndex', 'next');
        }
      }
    };
    configure.run('createComponent', prevOptions, app._callback);
    configure.run('createComponent', nextOptions, app._callback);
    _.defer(() => setNavigationArrowsStatus(app.getRenderableAttributes().length));
  };
  /* =====  End of Navigation Arrows  ====== */
  return {
    addBottomNavigationArrows,
    setNavigationArrowsStatus
  };
};

module.exports = NavigationArrows;
